"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validPointerTypes = exports.pointerTypeMappings = exports.typeMappings = exports.CHAR_POINTER_TYPE = exports.VOID_POINTER_TYPE = exports.FLOAT_POINTER_TYPE = exports.INT_POINTER_TYPE = exports.CHAR_TYPE = exports.FLOAT_TYPE = exports.INT_TYPE = exports.VOID_TYPE = exports.DECLARED_BUT_NOT_YET_ASSIGNED = exports.FLOAT_PRECISION = exports.UNKNOWN_LOCATION = void 0;
exports.UNKNOWN_LOCATION = {
    start: {
        line: -1,
        column: -1
    },
    end: {
        line: -1,
        column: -1
    }
};
exports.FLOAT_PRECISION = 6;
exports.DECLARED_BUT_NOT_YET_ASSIGNED = Symbol('Used to implement hoisting');
exports.VOID_TYPE = 'void';
exports.INT_TYPE = 'int';
exports.FLOAT_TYPE = 'float';
exports.CHAR_TYPE = 'char';
exports.INT_POINTER_TYPE = 'int*';
exports.FLOAT_POINTER_TYPE = 'float*';
exports.VOID_POINTER_TYPE = 'void*';
exports.CHAR_POINTER_TYPE = 'char*';
exports.typeMappings = {
    void: exports.VOID_TYPE,
    int: exports.INT_TYPE,
    float: exports.FLOAT_TYPE,
    char: exports.CHAR_TYPE
};
exports.pointerTypeMappings = {
    void: exports.VOID_POINTER_TYPE,
    int: exports.INT_POINTER_TYPE,
    float: exports.FLOAT_POINTER_TYPE,
    char: exports.CHAR_POINTER_TYPE
};
exports.validPointerTypes = new Set([
    exports.VOID_POINTER_TYPE,
    exports.INT_POINTER_TYPE,
    exports.FLOAT_POINTER_TYPE,
    exports.CHAR_POINTER_TYPE
]);
//# sourceMappingURL=constants.js.map